import { useQuery } from "@tanstack/react-query";
import permissionRepository from "@/repository/permissionRepository";


const getData = async (scenarioId: string) => {
    const res = await permissionRepository.find(scenarioId);
    return res.data || [];
};

export const usePermissions = (scenarioId: string) => {
    return useQuery({
        queryKey: ['scenario-permissions', scenarioId],
        queryFn: async () => getData(scenarioId),
        retry: false,
        enabled: !!scenarioId
    });
};
